import {
	container,
	title,
	description,
	section,
	btnLink,
	twitterColor,
	dribbbleColor,
	instagramColor,
	grayColor,
} from "assets/jss/material-kit-pro-react.js";

import imagesStyles from "assets/jss/material-kit-pro-react/imagesStyles.js";

const style = {
	...imagesStyles,
	container,
	title,
	description,
	section: {
		...section,
		padding: "70px 0px",
	},
	socialFeed: {
		"& p": {
			display: "table-cell",
			verticalAlign: "top",
			overflow: "hidden",
			paddingBottom: "10px",
			maxWidth: 300,
		},
		"& i": {
			fontSize: "20px",
			display: "table-cell",
			paddingRight: "10px",
		},
	},
	img: {
		width: "20%",
		marginRight: "5%",
		marginBottom: "5%",
		float: "left",
	},
	list: {
		marginBottom: "0",
		padding: "0",
		marginTop: "0",
	},
	inlineBlock: {
		display: "inline-block",
		padding: "0px",
		width: "auto",
	},
	left: {
		float: "left!important",
		display: "block",
	},
	right: {
		padding: "15px 0",
		margin: "0",
		float: "right",
	},
	aClass: {
		textDecoration: "none",
		backgroundColor: "transparent",
	},
	block: {
		color: "inherit",
		padding: "0.9375rem",
		fontWeight: "500",
		fontSize: "12px",
		textTransform: "uppercase",
		borderRadius: "3px",
		textDecoration: "none",
		position: "relative",
		display: "block",
	},
	footerBrand: {
		height: "50px",
		padding: "15px 15px",
		fontSize: "18px",
		lineHeight: "50px",
		marginLeft: "-15px",
		color: grayColor[1],
		textDecoration: "none",
		fontWeight: 700,
		fontFamily: "Roboto Slab,Times New Roman,serif",
	},
	footerLogo: {
		width: "70px",
	},
	footerTitle: {
		color: "#FFFFFFFF",
		fontSize: "16px",
		fontFamily: "Rubik-regular",
		textAlign: "center",
		fontWeight: "500",
		marginTop: "5px",
	},
	footerHeader: {
		color: "#073450FF",
		fontSize: "18px",
		fontFamily: "Rubik-Medium",
		paddingBottom: "5px",
		fontWeight: "500",
		marginTop: "5px",
	},
	footerSaasLogo: {
		width: "100%",
		color: "#073450FF",
		fontSize: "63px",
		fontFamily: "Rubik-Medium",
	},
	footerSaasBottom: {
		width: "100%",
		color: "#073450FF",
		fontSize: "27px",
		marginTop: "-23px",
		fontFamily: "Rubik-regular",
	},
	subscribe: {
		// textAlign: "right",
	},
	liUrl: {
		textTransform: "lowercase !important",
		color: "#073450FF",
	},
	liUrlA: {
		textTransform: "Capitalize !important",
		color: "#073450FF",
	},
	address: {
		color: "#073450FF",
		fontSize: "16px !important",
		fontFamily: "Rubik-regular",
		textAlign: "justify",
		margin: "0px",
		// marginTop: "10px",
		marginBottom: "10px",
		marginLeft: "5px",
		// "& span": {
		// 	color: "#237DB5FF",
		// 	fontSize: "14px",
		// 	textAlign: "left",
		// 	fontWeight: "400",
		// 	marginRight: "5px",
		// 	fontFamily: "Rubik-Medium",
		// },
	},
	footerInput: {
		display: "flex",
		flexDirection: "column",
		alignItems: "right",
	},
	pullCenter: {
		display: "inline-block",
		float: "none",
	},
	pullRight: {},
	rightLinks: {
		float: "right!important",
		"& ul": {
			marginBottom: 0,
			padding: 0,
			listStyle: "none",
			"& li": {
				display: "inline-block",
			},
			"& a": {
				display: "block",
			},
		},
		"& i": {
			fontSize: "20px",
		},
	},
	linksVertical: {
		"& li": {
			display: "block !important",
			marginLeft: "-5px",
			marginRight: "-5px",
			"& a": {
				padding: "5px !important",
			},
		},
	},
	footerLinks: {
		"& li": {
			display: "block !important",
			marginLeft: "-5px",
			marginRight: "-5px",

			"& a": {
				padding: "5px !important",
				fontSize: "16px !important",
				fontFamily: "Rubik-regular !important",
				color: "#073450FF !important",
			},
		},
	},
	footer: {
		textAlign: "left",
		"& ul li": {
			display: "inline-block",
		},
		"& h4, & h5": {
			color: grayColor[1],
			textDecoration: "none",
		},
		"& ul:not($socialButtons) li a": {
			color: "inherit",
			padding: "0.9375rem",
			fontWeight: "500",
			fontSize: "12px",
			textTransform: "uppercase",
			borderRadius: "3px",
			textDecoration: "none",
			position: "relative",
			display: "block",
		},
		"& small": {
			fontSize: "75%",
			color: grayColor[10],
		},
		"& $pullCenter": {
			display: "inline-block",
			float: "none",
		},
	},
	iconSocial: {
		width: "41px",
		height: "41px",
		fontSize: "24px",
		minWidth: "41px",
		padding: 0,
		overflow: "hidden",
		position: "relative",
	},
	copyRight: {
		padding: "15px 0px",
		textAlign: "left",
	},
	lineFooter: {
		border: "0",
		height: "1px",
		boxShadow:
			"0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(7, 42, 64, 0.46)",
		backgroundColor: "#073450FF",
	},
	socialButtons: {
		"& li": {
			display: "inline-block",
		},
		textAlign: "right",
	},
	btnTwitter: {
		...btnLink,
		color: twitterColor,
	},
	btnDribbble: {
		...btnLink,
		color: dribbbleColor,
	},
	btnInstagram: {
		...btnLink,
		color: instagramColor,
	},
	icon: {
		top: "3px",
		width: "18px",
		height: "18px",
		position: "relative",
	},
	customFormControl: {
		paddingTop: "14px",
	},
};

export default style;
